import { DateTime } from 'luxon';

import ChartActionId from '@/common/enums/chart-action-id.enum';
import ChartGroupActionType from '@/common/enums/chart-group-action-type.enum';
import ChartTimezoneType from '@/common/enums/chart-timezone-type.enum';
import ChartAction from '@/common/models/chart/ChartAction';
import ChartGroupAction from '@/common/models/chart/ChartGroupAction';
import store from '@/store';
import timezones from '@/utils/Timezones';

const defaultTz = 'Unit Local';
const userTz = DateTime.local().zoneName;
const timezoneList = timezones;
const orgTz = (): string => store.getters?.['orgApp/currentOrganization']?.timezone || 'local';

const suggestedTz = (): string[] => {
  const tzs = [defaultTz, userTz, 'UTC'];
  if (orgTz() && tzs.indexOf(orgTz()) === -1) {
    tzs.push(orgTz());
  }
  return tzs;
};

const defaultOptions = [defaultTz, ...timezoneList].map((tz, i) => new ChartAction(tz, false, tz, i));

const ChartTimezoneGroupActions = (
  rank: number,
  isHighlighted: boolean,
  optionsList: string[],
  selectedOption?: string,
): ChartGroupAction => {
  const options = optionsList?.length
    ? optionsList.map((o) => ({ ...defaultOptions.find((d) => d.id === o), isSelected: selectedOption === o }))
    : defaultOptions;

  return new ChartGroupAction(
    ChartActionId.TIMEZONE,
    ChartGroupActionType.TIMEZONE,
    'Timezone',
    rank,
    options,
    isHighlighted,
  );
};

const DefaultChartTimezoneWithUnitLocalGroupActions = ChartTimezoneGroupActions(
  0,
  false,
  [defaultTz, ...timezoneList],
  defaultTz,
);

const DefaultChartTimezoneWithVisibleUnitLocalGroupActions = ChartTimezoneGroupActions(
  0,
  true,
  [defaultTz, ...timezoneList],
  defaultTz,
);

const DefaultChartTimezoneGroupActions = ChartTimezoneGroupActions(0, false, timezoneList, userTz);

function localizedDate(value: number, zone: string, defaultZone = false): DateTime {
  return zone === ChartTimezoneType.UNIT_LOCAL
    ? DateTime.fromMillis(Number(value), { zone: defaultZone ? orgTz() : 'local' })
    : DateTime.fromMillis(Number(value), { zone });
}

function isInTheSameTimezone(firstTz: string, secondTz: string): boolean {
  return DateTime.local().setZone(firstTz).toFormat('Z') === DateTime.local().setZone(secondTz).toFormat('Z');
}

const ChartTimezoneGroupActionsUtils = {
  ChartTimezoneGroupActions,
  DefaultChartTimezoneGroupActions,
  DefaultChartTimezoneWithUnitLocalGroupActions,
  DefaultChartTimezoneWithVisibleUnitLocalGroupActions,
  defaultTz,
  isInTheSameTimezone,
  localizedDate,
  suggestedTz,
  timezoneList,
  userTz,
};

export default ChartTimezoneGroupActionsUtils;
